// extracted by mini-css-extract-plugin
export default {"clientProcessingFeePercentage":"InvoicesForm_clientProcessingFeePercentage__aYAE3"};